export const DefaultTimezone = 'America/New_York';

export const AthenaRawStatus = {
  CANCELED: 'x',
  FILLED: 'f',
};

export const ScheduledCallTabs = {
  UPCOMING: {
    text: 'Upcoming',
  },
  PAST: {
    text: 'Past',
  },
  CANCELED: {
    text: 'Canceled',
  },
  ALL: {
    text: 'All Visits',
  },
};

export const ScheduledCallStatus = {
  SCHEDULED: 'scheduled',
  RESCHEDULED: 'rescheduled',
  TODAY: 'today',
};
